import LogUser from "@/service/LogUser.js";

const state = {
  logInfo: {}
};

const mutations = {
  insertLog(state, obj) {
    state.logInfo = obj;
    this._vm.$cathayAxios.post(LogUser.insertLog, obj);
  }
};

const actions = {
  insertLog(context, obj) {
    context.commit("insertLog", obj);
  }
};

export default {
  state,
  mutations,
  actions
};
